<ada-card
	#ContentPropertiesCard
	id="ContentPropertiesCard"
	[collapseEnabled]="true"
	[verticalSpacing]="'Small'"
	width="100%"
>
	<ada-text
		id="ContentPropertiesCardHeader"
		data-container-selector="ada-card-header"
		content="Content Properties"
	></ada-text>
	<ada-container
		data-container-selector="ada-card-body"
		[colCount]="4"
		verticalSpacing="Medium"
		horizontalSpacing="Medium"
		[padding]="defaultCardPadding"
	>
		<ng-container *ngIf="'ContentId' | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#ContentIdLabel
				id="ContentIdLabel"
				[content]="'Content ID'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				[inheriting]="currentPropertyObject?.ContentId | inheritPipe : inheritedPropertyObject?.ContentId"
				[isRequired]="('ContentId' | isRequiredProperty : editorClass : propertyConstructor.namespace) || (currentPropertyObject | adaContentIdRequired)"
				[isDisabled]="isDisabled"
				(inheritanceChange)="deleteObjectPropertyValue('ContentId')"
			></ada-authoring-property-label>
			<ada-container
				[colSpan]="3"
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#ContentIdInput
					id="ContentIdInput"
					[type]="'text'"
					[placeholder]="'Content ID'"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[debounce]="100"
					[maxCharacterLimit]="255"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.ContentId"
					[isDisabled]="isDisabled"
					(valueChange)="setObjectPropertyValue('ContentId', $event)"
				></ada-input>
			</ada-container>
		</ng-container>
		<ng-container *ngIf="'SourceType' | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#SourceTypeLabel
				id="SourceTypeLabel"
				[content]="'Source Type'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				[isRequired]="'SourceType' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[isDisabled]="isDisabled"
			></ada-authoring-property-label>
			<ada-container
				[colSpan]="3"
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-combo
					#SourceTypeInput
					id="SourceTypeInput"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[options]="sourceTypeOptions"
					[value]="currentPropertyObject?.SourceType"
					[isDisabled]="isDisabled"
					(valueChange)="setObjectPropertyValue('SourceType', $event)"
				></ada-combo>
			</ada-container>
		</ng-container>
		<ng-container *ngIf="'VendorUrl' | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#VendorUrlLabel
				id="VendorUrlLabel"
				[content]="'Vendor URL'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				[inheriting]="currentPropertyObject?.VendorUrl | inheritPipe:inheritedPropertyObject?.VendorUrl"
				[isRequired]="('VendorUrl' | isRequiredProperty : editorClass : propertyConstructor.namespace) || (currentPropertyObject | adaVendorUrlRequired)"
				[isDisabled]="isDisabled"
				(inheritanceChange)="deleteObjectPropertyValue('VendorUrl')"
			></ada-authoring-property-label>
			<ada-container
				[colSpan]="3"
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#VendorUrlInput
					id="VendorUrlInput"
					[type]="'text'"
					[placeholder]="'Vendor URL'"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[maxCharacterLimit]="8000"
					[debounce]="100"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.VendorUrl"
					[isDisabled]="isDisabled"
					(valueChange)="setObjectPropertyValue('VendorUrl', $event)"
				></ada-input>
			</ada-container>
		</ng-container>
		<ng-container *ngIf="'AdaptivaUrl' | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#AdaptivaUrlLabel
				id="AdaptivaUrlLabel"
				[content]="'Adaptiva URL'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				[inheriting]="currentPropertyObject?.AdaptivaUrl | inheritPipe : inheritedPropertyObject?.AdaptivaUrl"
				[isRequired]="('AdaptivaUrl' | isRequiredProperty : editorClass : propertyConstructor.namespace) || (currentPropertyObject | adaAdaptivaUrlRequired)"
				[isDisabled]="isDisabled"
				(inheritanceChange)="deleteObjectPropertyValue('AdaptivaUrl')"
			></ada-authoring-property-label>
			<ada-container
				[colSpan]="3"
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-container
					class="placeholder-input-container ada-border-bottom ada-border-foreground"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[overflowX]="'hidden'"
				>
					<span
						class="file-upload-display-input"
						title="{{currentPropertyObject?.AdaptivaUrl}}"
						[class.ada-is-disabled]="!(!!currentPropertyObject?.AdaptivaUrl)"
					>
						{{currentPropertyObject?.AdaptivaUrl || pendingFileUploadMessage || 'Adaptiva URL'}}
					</span>
					<span
						class="upload-file-browse-btn ada-color-primary"
						[class.ada-is-disabled]="(uploadAllowed$ | async) === false || isDisabled || !(currentPropertyObject?.SourceType | uploadAllowedPipe)" 
						(click)="openUploadOverlay()"
						title="Upload a file"
					>
						UPLOAD
					</span>
				</ada-container>
			</ada-container>
		</ng-container>
		<ng-container *ngIf="'FileName' | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#FileNameLabel
				id="FileNameLabel"
				[content]="'File Name'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				[inheriting]="currentPropertyObject?.FileName | inheritPipe:inheritedPropertyObject?.FileName"
				[isRequired]="currentPropertyObject?.SourceType | fileNameRequiredPipe : inheritedPropertyObject?.FileName"
				[canInheritWhenRequired]="true"
				[isDisabled]="isDisabled"
				(inheritanceChange)="deleteObjectPropertyValue('FileName')"
			></ada-authoring-property-label>
			<ada-container
				[colSpan]="3"
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#FileNameInput
					id="FileNameInput"
					[type]="'text'"
					[placeholder]="'Original File Name'"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[maxCharacterLimit]="255"
					[debounce]="100"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.FileName !== undefined ? currentPropertyObject?.FileName : inheritedPropertyObject?.FileName"
					[isDisabled]="isDisabled"
					(userInput)="setObjectPropertyValue('FileName', $event)"
				></ada-input>
			</ada-container>
		</ng-container>
		<ng-container *ngIf="'Sha256Hash' | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#Sha256HashLabel
				id="Sha256HashLabel"
				[content]="'Sha256 Hash'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				[inheriting]="currentPropertyObject?.Sha256Hash | inheritPipe:inheritedPropertyObject?.Sha256Hash"
				[isRequired]="('Sha256Hash' | isRequiredProperty : editorClass : propertyConstructor.namespace) || (currentPropertyObject | adaContentIdRequired)"
				[isDisabled]="isDisabled"
				(inheritanceChange)="deleteObjectPropertyValue('Sha256Hash')"
			></ada-authoring-property-label>
			<ada-container
				[colSpan]="3"
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#Sha256HashInput
					id="Sha256HashInput"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[type]="'text'"
					[placeholder]="'Sha256 Hash'"
					[debounce]="100"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.Sha256Hash"
					[isDisabled]="isDisabled"
					(valueChange)="setObjectPropertyValue('Sha256Hash', $event)"
				></ada-input>
			</ada-container>
		</ng-container>
		<ng-container *ngIf="'Size' | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#SizeLabel
				id="SizeLabel"
				[content]="'Size'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				[inheriting]="currentPropertyObject?.Size | inheritPipe:inheritedPropertyObject?.Size"
				[isRequired]="('Size' | isRequiredProperty : editorClass : propertyConstructor.namespace) || (currentPropertyObject | adaContentIdRequired)"
				[isDisabled]="isDisabled"
				(inheritanceChange)="deleteObjectPropertyValue('Size')"
			></ada-authoring-property-label>
			<ada-container
				[colSpan]="3"
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#SizeInput
					id="SizeInput"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[type]="'number'"
					[min]="0"
					[placeholder]="'Size in bytes'"
					[debounce]="100"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.Size"
					[isDisabled]="isDisabled"
					(valueChange)="setObjectPropertyValue('Size', +$event)"
				></ada-input>
			</ada-container>
		</ng-container>
	</ada-container>
</ada-card>
<ada-overlay
	id="UploadOverlay"
	#UploadOverlay
	title="Upload"
	(submit)="submitUploadToCdn('Content')"
>
	<ada-container
		*adaTemplateMarker
		verticalSpacing="Medium"
		horizontalSpacing="Medium"
		[padding]="UI.Spacing.SPACING_LARGE"
	>
		<ada-container [colCount]="2">
			<ada-container [colSpan]="1">
				<ada-text
					[colSpan]="1"
					content="Upload to Adaptiva"
				></ada-text>
			</ada-container>
		</ada-container>
		<ada-container
			verticalSpacing="Medium"
		>
			<ada-file-uploader
				#FileUploader
				id="ObjectFileUploader"
				readAs="arrayBuffer"
				(fileChange)="uploadFileChange($event)"
			></ada-file-uploader>
		</ada-container>
	</ada-container>
</ada-overlay>
